module.exports = __webpack_public_path__ + "img/ia04.8a3b6329.png";